/* eslint-disable */

var counter = 0
var step = 10
var limitSeconds = 10
var limit = limitSeconds * 1000 / step

if (document.readyState !== 'loading') {
    waitForJQuery()
    navbarLogic()
    seasonalTime()
}else{
    document.addEventListener('DOMContentLoaded', waitForJQuery())
    document.addEventListener('DOMContentLoaded', navbarLogic)
    document.addEventListener('DOMContentLoaded', seasonalTime)
}

function waitForJQuery() {
    if ($) {
        jqueryLogic()
    }else{
        if (counter >= limit)
            return

        setTimeout(function () {
            counter += step
            waitForJQuery()
        }, step)
    }
}

function jqueryLogic() {
    $(document).ready(function() {

        // grab the image thumbnails from gallery and add to array
        var imgArray = [];
        $('#pictures-anchor + .thumb li a img').each(function(){
            imgArray.push($(this).attr('src'));
        });
        // for each video, grab a random image from thumbnail gallery for its thumbnail
        $('.video img').each(function(){
            $(this).attr('src', imgArray[Math.floor(Math.random()*imgArray.length)]);
        });


        // change youtube links from the standard 'watch' url to the 'embed' url
        var youtubeLinkChange = function(){
            $('.video li a').each(function(){
                var newUrl = $(this).attr('href').replace('watch?v=', 'embed/');
                $(this).attr('href', newUrl);
            });
        }
        youtubeLinkChange();


        // smooth scroll on button click functionality (i.e. back to top)
        var smooth_scroll = function(to_container) {
            var $root = $('html,body');
            $root.animate({
                scrollTop: $(to_container).offset().top
            }, 1000, function(){
                //animation complete
            });
            return false;
        };


        // once fancybox js is loaded, start doing fancybox things
        if($('.fancybox')){
          	$('head').append('<link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.7/dist/jquery.fancybox.min.css" />')

            $.when($.getScript("https://cdn.jsdelivr.net/gh/fancyapps/fancybox@3.5.7/dist/jquery.fancybox.js"))
                .done(function() {

                    // fancybox lightbox settings
                    $('.fancybox').fancybox({
                        padding: 0,
                        prevEffect: 'fade',
                        nextEffect: 'fade',
                        buttons: true,
                        thumbs: true,
                        zoom: true,
                        buttons: [
                            "zoom",
                            //"share",
                            "slideShow",
                            //"fullScreen",
                            //"download",
                            "close"
                            ],
                        helpers: {
                            title: {
                                type: 'outside'
                            },
                            thumbs: {
                                width: 100,
                                height: 100,
                                source: function(current) {
                                    return $(current.element).attr('href');
                                }
                            }
                        }
                    });
                });

        }

        // active navigation highlighting
        var currentUrl = window.location.href;
        if(currentUrl.indexOf("ranger-boats-brochure") > -1 || currentUrl.indexOf("/pages/ranger-") > -1) {
            $('.variation-page #nav .navbar-nav > li > a[href="/collections/current-inventory/ranger-boats"]').addClass('active');
            $('.variation-page #nav .navbar-nav li a[href="/pages/ranger-boats-brochure"]').addClass('active');
        } else if(currentUrl.indexOf("lund-boats-brochure") > -1 || currentUrl.indexOf("/pages/lund-") > -1) {
            $('.variation-page #nav .navbar-nav > li > a[href="/collections/current-inventory/lund-fishing-boats"]').addClass('active');
            $('.variation-page #nav .navbar-nav li a[href="/pages/lund-boats-brochure"]').addClass('active');
        } else if(currentUrl.indexOf("sylvan-pontoons-brochure") > -1 || currentUrl.indexOf("/pages/sylvan-") > -1) {
            $('.variation-page #nav .navbar-nav > li > a[href="/collections/current-inventory/sylvan-pontoon-boats"]').addClass('active');
            $('.variation-page #nav .navbar-nav li a[href="/pages/sylvan-pontoons-brochure"]').addClass('active');
        } else if(currentUrl.indexOf("triton-boats-brochure") > -1 || currentUrl.indexOf("/pages/triton-") > -1) {
            $('.variation-page #nav .navbar-nav > li > a[href="/collections/current-inventory/triton-boats"]').addClass('active');
            $('.variation-page #nav .navbar-nav li a[href="/pages/triton-boats-brochure"]').addClass('active');
        } else {
            var handle = $('.product-detail .manufacturer').text().trim().replace(/ /g, '-').toLowerCase();
            $('.variation-page #nav .navbar-nav li a[href="/collections/current-inventory/' + handle + '"]').addClass('active');
        }


        // mfg selecting and sorting (current inventory)
        $('article.ranger-boats').insertBefore($('article.lund-fishing-boats:first')); //place ranger ahead of other mfgs

        $('.manufacturer-select .btn').click(function(e){
            e.preventDefault(); //prevent default behavior of links
            var clickedBtn = $(this).attr('id');
            if(clickedBtn == 'ranger'){
                $('.manufacturer-select .btn').removeClass('active');
                $(this).addClass('active');
                $('article.ranger-boats').fadeIn();
                $('article.lund-fishing-boats, article.sylvan-pontoon-boats, article.triton-boats, article.used-boats').fadeOut();
                smooth_scroll('.products');
            }
            if(clickedBtn == 'lund'){
                $('.manufacturer-select .btn').removeClass('active');
                $(this).addClass('active');
                $('article.lund-fishing-boats').fadeIn();
                $('article.ranger-boats, article.sylvan-pontoon-boats, article.triton-boats, article.used-boats').fadeOut();
                smooth_scroll('.products');
            }
            if(clickedBtn == 'sylvan'){
                $('.manufacturer-select .btn').removeClass('active');
                $(this).addClass('active');
                $('article.sylvan-pontoon-boats').fadeIn();
                $('article.ranger-boats, article.lund-fishing-boats, article.triton-boats, article.used-boats').fadeOut();
                smooth_scroll('.products');
            }
            if(clickedBtn == 'triton'){
                $('.manufacturer-select .btn').removeClass('active');
                $(this).addClass('active');
                $('article.triton-boats').fadeIn();
                $('article.ranger-boats, article.lund-fishing-boats, article.sylvan-pontoon-boats, article.used-boats').fadeOut();
                smooth_scroll('.products');
            }
            if(clickedBtn == 'used'){
                $('.manufacturer-select .btn').removeClass('active');
                $(this).addClass('active');
                $('article.used-boats').fadeIn();
                $('article.ranger-boats, article.lund-fishing-boats, article.sylvan-pontoon-boats, article.triton-boats').fadeOut();
                smooth_scroll('.products');
            }
        });


        // smooth scroll for video/pictures buttons on current inventory product page
        if ( $('#video-button').length && !$('#videos-anchor').length ) {
    	    $('#video-button').remove();
        } else {
    	    $('#video-button').click(function(){
    	        $(this).addClass('smooth-scroll');
    	        smooth_scroll('#videos-anchor');
    	    });
        }

        $('#picture-button').click(function(){
            $(this).addClass('smooth-scroll');
            smooth_scroll('#pictures-anchor');
        });


        //  contact us form functionality

        $('form.contact-form').on("submit", function(e) {
            e.preventDefault();

            var form_action = $(this).attr('action');
            var form_data   = $(this).serialize();

            $.ajax({
                type: 'POST',
                url: form_action,
                data: form_data,
                async: true,
                dataType: 'json',

                complete: function(result, textStatus, dis) {
                    if ( parseInt(result.status) == 200 ) {
                        alert("Your message was successfully sent.");
                        sendFormAnalytics();
                        $('form').each(function(){
                            this.reset();
                        });
                    }else{
                        const contactForm = document.getElementById('form-in-contact')
                        const contactAddresses = document.getElementById('contact-addresses')
                        const formTitleText = document.querySelector('.heading')
                        contactForm.setAttribute('hidden', '')
                        formTitleText.setAttribute('hidden', '')
                        contactAddresses.removeAttribute('hidden', '')
                    }
                }
            })
            return false;
        });

    });
}


function navbarLogic() {
// Fix #7 JQuery load after Bootstrap on Iphones (at least IPhone 6, IOS 12)
// which leads to navbar not working

    var burgerButton = document.querySelectorAll('header .navbar-toggle')[0]
    var navbar = document.getElementById('navbar')
    var navbarIsChecked = false

    burgerButton.addEventListener('click', checkIfNavbarIsWorking)

    function checkIfNavbarIsWorking() {
        if (navbarIsChecked)
            return

        setTimeout(function() {
            var navbarIsShown = navbar.getAttribute('aria-expanded')

            navbarIsChecked = true
            if (navbarIsShown)
                return

            burgerButton.addEventListener('click', toggleNavbar)
            toggleNavbar()
        }, 20)
    }


    function toggleNavbar() {
        burgerButton.classList.toggle('collapsed')
        navbar.classList.toggle('in')
        navbar.setAttribute('aria-expanded', ! navbar.getAttribute('aria-expanded'))
    }
}

function seasonalTime() {
    var currentMonth = new Date().getMonth() + 1
    var winterMonths = [1, 9, 10, 11, 12]
    var isWinter = winterMonths.includes(currentMonth)
    var el = document.getElementById('seasonal-time')
    if (el) {
        var hours = isWinter ? el.dataset.winter : el.dataset.summer
        if (hours) el.textContent = hours
    }
}
